import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { getValuesFromLocalstorage } from '../../Helpers';

const RecruiterRoute = () => {
  const userDetails = getValuesFromLocalstorage('userDetails');
  
  // Only RECRUITER users can access these routes
  const isRecruiter = userDetails?.acctType === "RECRUITER" || userDetails?.acctType === "ADMIN";
  
  console.log("Recruiter route check:", { 
    userDetails, 
    isRecruiter,
    pathname: window.location.pathname
  });
  
  // If not recruiter, redirect to dashboard
  return isRecruiter ? <Outlet /> : <Navigate to="/" />;
};

export default RecruiterRoute; 